/* eslint-disable no-unused-vars */
/* eslint-disable no-prototype-builtins */
import { showmore } from '../../../../core/showmore';
import { slugCreator } from '../../../../core/useStore';
import { resolveRefs } from '../../../../helpers/resolver';
/**
 * menuSpecResults
 * @param {spec} data
 * @param {string} path
 * @param {string} method
 * @returns
 */
const menuSpecResults = async (link, item, data, xindex, parent) => {
  if (data.length === 0) {
    return [];
  }
  // Custom resolver missions
  const resolved = data;
  const result = resolved.paths;
  const servers = resolved.servers;
  // const result = data.paths;
  let items = [];
  result &&
    (await Object.keys(result).forEach(async function (key) {
      let methods = result[key];
      let submenu = [];
      let tag = '';
      let operationId = '';
      await Object.keys(methods).map(function (key1, index) {
        tag = methods[key1]?.tags?.length > 0 ? methods[key1]?.tags[0] : 'Other';
        operationId = index + 1000 * Math.random() + Math.random();
        submenu.push({
          id: slugCreator(
            `${methods[key1]?.api_display_name}-${tag}-1000-${operationId}-${key1}-${key}`,
          ),
          key: tag,
          operation: operationId,
          api_status: item?.api_status || '',
          apiMachineName: item?.name || '',
          status: 1,
          original: methods[key1].api_display_name,
          method: key1,
          servers: servers,
          name: methods[key1].summary
            ? methods[key1].summary
            : methods[key1].name
            ? methods[key1].name
            : methods[key1].description
            ? methods[key1].description
            : '',
          type: 'api-contract',
          postman: parent.postman,
          spec: methods[key1],
          description: methods[key1].description || '',
          version: item?.version || '',
          apiVersion: item?.version || '',
          shorttitle: methods[key1]?.summary?.substring(0, 143) + '...' || '...',
          techReference: item?.techReference || '',
          parentTitle: item?.api_display_name || '',
          parentTechRef: parent.techReference || '',
          specPath: key,
          link: `${link}?path=${key}&method=${key1}`,
          path: `${link}?path=${key}&method=${key1}`,
          sourcePath: `${key}`,
          filePath: `/apis/${item?.name}/${item?.version}`,
        });
      });
      let indexCheck = items.findIndex((itemX) => itemX.tag === tag);
      if (indexCheck > -1) {
        const before = items[indexCheck].value;
        items[indexCheck].value = [...before, ...submenu];
      } else {
        items.push({
          id: slugCreator(key + item?.version + item?.name),
          key: key,
          method: '',
          servers: servers,
          operation: methods[key]?.operationId || '',
          spec: resolved,
          techReference: item?.techReference || '',
          description: methods[key]?.description || '',
          value: submenu,
          specPath: key,
          sourcePath: `${key}`,
          filePath: `/apis/${item?.name}/${item?.version}`,
          link: `${link}?path=${key}`,
          path: `${link}?path=${key}`,
          tag: tag,
        });
      }
    }));
  return items;
};
let requiredList = [];
function mergeSchemas(schema) {
  const listOfNot = [];
  if (schema?.allOf) {
    // Recursively merge all properties of each schema in the allOf array
    const properties = schema.allOf.reduce((acc, curr) => {
      const result = mergeSchemas(curr);
      if (acc === 'required' && typeof curr === 'object') {
        curr.forEach((x) => requiredList.push(x));
      } else if (curr?.required && typeof curr?.required === 'object') {
        curr?.required.forEach((x) => requiredList.push(x));
      }
      const final = result?.properties ? result?.properties : result;
      if (requiredList.indexOf(acc)) {
        const finalR = { ...final, required: true };
        return { ...acc, ...finalR };
      }
      return { ...acc, ...final };
    }, {});

    // Return a new schema with the merged properties
    return { properties };
  } else if (schema === 'allOf') {
    // Recursively merge all properties of each schema in the allOf array
    const properties = schema.reduce((acc, curr) => {
      const result = mergeSchemas(curr);
      const final = result?.properties ? result?.properties : result;
      return { ...acc, ...final };
    }, {});

    // Return a new schema with the merged properties
    return { properties };
  } else {
    // If the schema doesn't have allOf, return it as is
    return schema?.properties || schema?.items || schema;
  }
}
/**
 *
 * @param {spec} data
 * @param {string} path
 * @param {string} method
 * @returns
 */
const rightRegionResults = async (link, item, data, path = false, method = false) => {
  // Custom resolver missions
  const resolved = data;
  const result = resolved.paths;
  // const result = data.paths;
  let items = [];
  await Object.keys(result).forEach(async function (key) {
    let methods = result[key];
    let submenu = [];
    let tag = '';

    await Object.keys(methods).map(function (key1, index) {
      tag = methods[key1]?.operationId
        ? methods[key1].operationId
        : methods[key1]?.tags?.length > 0
        ? methods[key1]?.tags[0]
        : 'Other';

      submenu.push({
        id: index + 888,
        key: key,
        api_status: item?.api_status || '',
        apiMachineName: item?.name || '',
        status: 1,
        name: methods[key1].summary,
        type: 'api-contract',
        spec: methods[key1] || [],
        specPath: key,
        description: methods[key1].description || '',
        version: item?.version || '',
        shorttitle: methods[key1].summary.substring(0, 143) + '...',
        techReference: item?.techReference || '',
        link: `${link}?path=${key}&method=${key1}`,
        filePath: `/apis/${item?.name}/${item?.version}`,
      });
      let index1 = items.findIndex((x) => x.tag === tag);
      if (index1 > -1) {
        //
      } else {
        items.push({
          key: key,
          spec: methods[key1],
          specPath: key,
          description: methods[key1].description,
          techReference: item?.techReference,
          value: submenu,
          tag: tag,
        });
      }
    });
  });
  //

  // return items;
  //
  if (path !== null) {
    if (method !== null) {
      let index = items.map((x) => {
        if (x.key === path && x.value.findIndex((y) => y.key === method) !== -1) {
          let now = x.value.findIndex((y) => y.key === method);
          let clear = x.value[now];
          return clear;
        }
      });
      return index;
    } else {
      return items.filter((x) => x.key === path);
    }
  } else {
    return items;
  }
};
function JsonViewer(
  json,
  collapsible = true,
  propertiesField = false,
  parameters = false,
  requiredFields,
) {
  requiredList = [];
  let TEMPLATES = {
    item: '<div ><b>%KEY%</b> %VALUE%</div>',
    itemCollapsible: `<details ${
      parameters ? 'class="params detailsOpenClose"' : 'class="detailsOpenClose mb-2 mt-2"'
    }><summary ><b>%KEY%</b>%VALUE% %LENGTH% <span class="required-key text-end">%REQ%</span></summary><section>%CHILDREN%<section></details>`,
    itemCollapsibleOpen: `<details ${
      parameters ? 'class="params detailsOpenClose"' : 'class="detailsOpenClose mb-2 mt-2"'
    } open ><summary ><b>%KEY%</b>%VALUE% %LENGTH% <span class="required-key text-end">%REQ%</span></summary><section>%CHILDREN%<section></details>`,
  };
  // let requiredList = [];
  const hideCustom = ['in', 'schema', 'type', 'propField', 'required'];
  const hideCustom2 = ['in', 'schema', 'required', 'type', 'propField', 'title', 'name'];
  function createItem(key, value, type) {
    let newKey;
    if (key === 'required' && typeof value === 'object') {
      value.forEach((x) => requiredList.push(x));
    } else if (value?.required && typeof value?.required === 'object') {
      value?.required.forEach((x) => requiredList.push(x));
    }
    if (key.split('').length < 3 && key !== 'in' && key !== 'id') {
      newKey =
        value?.name ||
        value?.allOf?.name ||
        value?.schema?.name ||
        value?.title ||
        value?.summary ||
        value?.description ||
        value.allOf?.description ||
        key;
    } else if (key === 'properties' || key === 'allOf' || key === 'oneOf') {
      newKey =
        value?.name ||
        value?.allOf?.name ||
        value?.schema?.name ||
        value?.title ||
        value?.summary ||
        value?.description ||
        value.allOf?.description ||
        key;
    } else {
      newKey = key;
    }
    if (key === 'required' && typeof value === 'object') {
      value.forEach((x) => requiredList.push(x));
    }
    let required = requiredList?.indexOf(key) >= 0 || value?.required ? 'Required' : '';
    let element = TEMPLATES.item?.replaceAll('%REQ%', required);
    if (type == 'string') {
      if (key === 'additionalProperties') {
        element = element.replaceAll('%VALUE%', '"' + value + '"').replaceAll('%KEY%', '<*>');
      } else if (key === 'description') {
        element = element
          .replaceAll(
            '%VALUE%',
            value.length > 280 ? showmore(value, true) : showmore(value, false),
          )
          .replaceAll('%KEY%', '');
      } else if (key === 'properties') {
        element = element.replaceAll('%VALUE%', '"' + value + '"').replaceAll('%KEY%', '');
      } else if (hideCustom2.indexOf(key) < 0) {
        element = element.replaceAll('%VALUE%', '"' + value + '"').replaceAll('%KEY%', newKey);
      } else {
        element = '';
      }
    } else {
      if (value?.allOf) {
        value = mergeSchemas(value);
        element = element.replaceAll('%VALUE%', '').replaceAll('%KEY%', newKey);
      } else if (key === 'allOf') {
        value = mergeSchemas(value);
        element = element.replaceAll('%VALUE%', '').replaceAll('%KEY%', newKey);
      } else {
        element = element.replaceAll('%VALUE%', value).replaceAll('%KEY%', newKey);
      }
    }

    // if (key === 'items') {
    //   key = element.replaceAll('%TYPE%', '');
    // } else {
    const typeIs = value?.in ? value?.in : type;
    element = element.replaceAll('%TYPE%', typeIs);
    // }

    return element;
  }

  function createCollapsibleItem(key, value, type, children, clength) {
    let newKey;
    let tpl = 'itemCollapsible';
    let itemsField = value?.propField || false;
    if (key === 'required' && typeof value === 'object') {
      value.forEach((x) => requiredList.push(x));
    } else if (value?.required && typeof value?.required === 'object') {
      value?.required.forEach((x) => requiredList.push(x));
    }
    if (key.split('').length < 3 && key !== 'in' && key !== 'id') {
      newKey =
        value?.name ||
        value?.allOf?.name ||
        value?.schema?.name ||
        value?.summary ||
        value?.description ||
        value.allOf?.description ||
        '';
    } else {
      newKey = key;
    }

    if (key === 'items' || key === 'allOf') {
      itemsField = true;
    }

    if (collapsible || propertiesField || itemsField) {
      tpl = 'itemCollapsibleOpen';
    }

    const typeIs = value['in'] ? value['in'] : type;
    let required = requiredList?.indexOf(key) >= 0 || value?.required ? 'Required' : '';
    let element = TEMPLATES[tpl].replaceAll('%REQ%', required);
    if (key === 'additionalProperties') {
      element = element.replaceAll('%KEY%', '< * >');
    }

    // if (key === 'items') {
    //   key = element.replaceAll('%TYPE%', '');
    //   element = element.replaceAll('%VALUE%', ``);
    // } else {
    element = element.replaceAll('%KEY%', newKey).replaceAll('%TYPE%', type.toUpperCase());
    element = element.replaceAll(
      '%VALUE%',
      `<div class="json__value json__value--${type}">${type.toUpperCase()}</div> ${
        type === typeIs ? '' : `(<span class="key-upper">${typeIs}</span>)`
      }`,
    );
    // }
    element = element.replaceAll('%CHILDREN%', children);
    // Add length
    if (typeIs === 'object') {
      element = element.replaceAll('%LENGTH%', `{${clength}}`);
    } else {
      element = element.replaceAll('%LENGTH%', '');
    }
    return element;
  }

  function handleChildren(key, value, type) {
    let html = '';
    let clength = 0;
    if (key === 'required' && typeof value === 'object') {
      value.forEach((x) => requiredList.push(x));
    } else if (value?.required && typeof value?.required === 'object') {
      value?.required.forEach((x) => requiredList.push(x));
    }
    for (let item in value) {
      if (hideCustom.indexOf(key) < 0) {
        clength++;
      }

      let _key = item,
        _val = mergeSchemas(value[item]);
      if (_key === 'required' && typeof _val === 'object') {
        _val.forEach((x) => requiredList.push(x));
      } else if (_val?.required && typeof _val?.required === 'object') {
        _val?.required.forEach((x) => requiredList.push(x));
      }
      if (key === 'allOf') {
        _val = mergeSchemas(value);
        html += handleItem('', _val);
      } else if (_key.split('').length < 3 && _key !== 'in' && _key !== 'id') {
        html += handleItem(_key, _val);
      } else if (_key === 'items') {
        if (_val?.items) {
          if (_val?.items?.allOf) {
            _val = mergeSchemas(_val?.items);
          } else if (_val?.allOf) {
            _val = mergeSchemas(_val?.items);
          } else if (_key === 'allOf') {
            _val = mergeSchemas(_val?.items);
          }
          html += handleItem(_key, _val);
        }
        html += handleItem(_key, _val);
      } else {
        html += handleItem(_key, _val);
      }
    }

    return createCollapsibleItem(key, value, type, html, clength);
  }

  function handleEnum(value) {
    let html = '<div class="raw enum-list"><b>Enum: </b>';
    value.forEach((x) => {
      html += `<span class="enum-item">${x}</span>`;
    });
    html += '</div>';
    // html += `<br/><b>Default</b>  ${value[0]}</div>`;
    return html;
  }

  function handleItem(key, value) {
    let type = parameters
      ? 'STRING'
      : value?.type || value?.format || value?.schema?.type || typeof value;
    if (value?.schema?.type) {
      type = value?.schema?.type;
    }
    if (key === 'required' && typeof value === 'object') {
      value.forEach((x) => requiredList.push(x));
    } else if (value?.required && typeof value?.required === 'object') {
      value?.required.forEach((x) => requiredList.push(x));
    }
    if (value?.type) {
      type = value?.type;
    }
    if (value?.allOf) {
      value = mergeSchemas(value);
    }
    if (key === 'allOf') {
      value = mergeSchemas(value);
    }
    if (typeof value === 'object') {
      if (key === 'x-examples' && JSON.stringify(value) === '{}') {
        return '';
      }
      if (value?.properties) {
        value = mergeSchemas(value['properties']);
      } else if (value?.items) {
        value = mergeSchemas(value?.items);
      }
      if (key == 'schema') {
        return JsonViewer(value);
      }
      if (key === 'enum') {
        return handleEnum(value);
      } else if (hideCustom.indexOf(key) < 0) {
        return handleChildren(key, value, type.toString());
      } else {
        return '';
      }
    }

    if (hideCustom.indexOf(key) < 0) {
      return createItem(key, value, type.toString());
    } else {
      return '';
    }
  }

  // get requireds from external resources
  const reqGet = (obj) => {
    for (let item in obj) {
      let key = item,
        value = obj[item];
      if (key === 'required' && typeof value === 'object') {
        value.forEach((x) => requiredList.push(x));
      } else if (value?.required && typeof value?.required === 'object') {
        value?.required.forEach((x) => requiredList.push(x));
        // find nested children with required fields
        for (let childItem in value) {
          let childKey = childItem,
            childValue = value[childItem];
          if (childKey === 'properties' && typeof childValue === 'object') {
            Object.entries(childValue).forEach(([parentKey, childObj]) => {
              if (childObj?.required) {
                childObj?.required.forEach((y) => requiredList.push(y));
              }
            });
          }
        }
      } else if (value?.allOf?.required && typeof value?.allOf?.required === 'object') {
        value?.allOf?.required.forEach((x) => requiredList.push(x));
      }
    }
    return true;
  };

  // to find all required fields within children iteratively
  function findChildrenWithReqKey(obj, result = []) {
    const key = 'required';
    if (Array.isArray(obj)) {
      obj.forEach((item) => {
        if (item && typeof item === 'object' && item.hasOwnProperty(key)) {
          const requiredValue = item[key];
          if (requiredValue === true) {
            result.push(item.name);
          } else if (Array.isArray(requiredValue)) {
            result.push(...requiredValue);
          }
        }
      });
    } else if (obj && typeof obj === 'object') {
      Object.entries(obj).forEach(([parentKey, value]) => {
        if (value && typeof value === 'object') {
          if (value.hasOwnProperty(key)) {
            const requiredValue = value[key];
            if (Array.isArray(requiredValue)) {
              result.push(...requiredValue);
            } else if (requiredValue === true) {
              result.push(parentKey);
            }
          }
          findChildrenWithReqKey(value, result);
        }
      });
    }
    return result;
  }

  function parseObject(obj) {
    const nowRefresh = reqGet(obj);
    const matchNodes = findChildrenWithReqKey(obj);
    if (matchNodes) {
      requiredList.push(...matchNodes);
    }
    let result = `<section ${parameters ? ' class="params"' : ''}>`;
    for (let item in obj) {
      let key = item,
        value = obj[item];
      result += handleItem(key, value);
    }
    result += '</section>';
    return result;
  }
  if (requiredFields) {
    requiredList.push(...requiredFields);
  }
  return parseObject(json);
}

// Static codes messages
const codeMessage = [
  {
    code: '204',
    message: 'No Content',
  },
  {
    code: '200',
    message: '200 OK',
  },
  {
    code: '201',
    message: '201 Created',
  },
  {
    code: '300',
    message: '300 Multiple Choices',
  },
  {
    code: '301',
    message: '301 Moved Permanently',
  },
  {
    code: '302',
    message: '302 Found',
  },
  {
    code: '400',
    message: '400 Bad Request',
  },
  {
    code: '401',
    message: '401 Unauthorized',
  },
  {
    code: '403',
    message: '403 Forbidden',
  },
  {
    code: '404',
    message: '404 Not Found',
  },
  {
    code: '405',
    message: '405 Method Not Allowed',
  },
  {
    code: '407',
    message: '407 Proxy Authentication Required',
  },
  {
    code: '500',
    message: '500 Internal Server Error',
  },
  {
    code: '501',
    message: '501 Not Implemented',
  },
  {
    code: '502',
    message: '502 Bad Gateway',
  },
  {
    code: '503',
    message: '503 Service Unavailable',
  },
  {
    code: '504',
    message: '504 Gateway Timeout',
  },
  {
    code: '505',
    message: '505 HTTP Version Not Supported',
  },
  {
    code: '511',
    message: '511 Network Authentication Required',
  },
];
/**
 * findPath nested search
 * @param {spec} ob
 * @param {string} key
 * @returns
 */
const findPathNested = (ob, key) => {
  const path = [];
  const keyExists = (obj) => {
    if (!obj || (typeof obj !== 'object' && !Array.isArray(obj))) {
      return false;
    } else if (obj.hasOwnProperty(key)) {
      return true;
    } else if (Array.isArray(obj)) {
      let parentKey = path.length ? path.pop() : '';

      for (let i = 0; i < obj.length; i++) {
        path.push(`${parentKey}[${i}]`);
        const result = keyExists(obj[i], key);
        if (result) {
          return result;
        }
        path.pop();
      }
    } else {
      for (const k in obj) {
        path.push(k);
        const result = keyExists(obj[k], key);
        if (result) {
          return result;
        }
        path.pop();
      }
    }
    return false;
  };

  keyExists(ob);

  return findValueFromPath(ob, path.join('.'))?.description;
};
const findValueFromPath = (object, path) => {
  var valueOfPath = [];
  /* Create an array from path (keys) which are coming with dot separation */
  var pathsList = path.split('.');

  /* check for if first path (key) is existing else break condition and return undefined*/
  if (valueOfPath.indexOf(pathsList[0]) < 0 && object[pathsList[0]]) {
    /*
     update Array with splice now with first path (key) value so that we can check for next path(key) 
    in the same Array
    */

    valueOfPath.splice(0, valueOfPath.length, object[pathsList[0]]);

    /* Now iterate over left paths (keys) and check if their key-value exists in Array*/
    for (var i = 1; i < pathsList?.length; i++) {
      if (valueOfPath[0][pathsList[i]] != undefined) {
        /*Validate the next path is not undefined else handle that in else and break the loop */
        valueOfPath.splice(0, valueOfPath.length, valueOfPath[0][pathsList[i]]);
      } else {
        /* null should be returned explicitly */
        if (valueOfPath[0][pathsList[i]] === null) {
          valueOfPath.splice(0, valueOfPath.length, null);
        } else {
          /* if path (key) is not exisiting then simply return undefined and break the loop */
          valueOfPath.splice(0, valueOfPath.length, undefined);
        }
        break;
      }
    }
  } else {
    valueOfPath.splice(0, valueOfPath.length, undefined);
  }
  return valueOfPath[0];
};
// eslint-disable-next-line no-unused-vars
function collapseHelper(event) {
  // Fetch all the details element.
  const details = document.querySelectorAll('details');
  // Add the onclick listeners.
  details.forEach((targetDetail) => {
    targetDetail.removeAttribute('open');
  });
}
// eslint-disable-next-line no-unused-vars
function expandCollapseHelper(event) {
  // Fetch all the details element.
  const details = document.querySelectorAll('details');
  // Add the onclick listeners.
  details.forEach((targetDetail) => {
    targetDetail.setAttribute('open', true);
  });
}
export {
  menuSpecResults,
  rightRegionResults,
  JsonViewer,
  mergeSchemas,
  codeMessage,
  findPathNested,
  expandCollapseHelper,
  collapseHelper,
};
